import { raf, caf } from './raf';
export default function (cb) {
    var timer = null;
    var throttle = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        timer && caf(timer);
        timer = raf(function () {
            cb.apply(void 0, args);
            timer = null;
        });
    };
    throttle.cancel = function () {
        caf(timer);
        timer = null;
    };
    return throttle;
}
